import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { TicketsService } from 'src/app/services/tickets-service/tickets.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { DeviceBasic } from 'src/app/models/device-models/device-basic-model/device-basic.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { Location } from 'src/app/models/turns-models/location.model';
import { tap } from 'rxjs/operators';
import { SmsService } from 'src/app/services/sms-service/smsservice';

@Component({
  selector: 'app-turns-desk-dashboard',
  templateUrl: './turns-desk-dashboard.component.html',
  styleUrls: ['./turns-desk-dashboard.component.scss']
})
export class TurnsDeskDashboardComponent implements OnInit, OnDestroy {

  desk;
  smsList;
  ticketList;
  devices: DeviceBasic[];
  assignedDevices: DeviceBasic[];
  assignedLocations: Location[];
  deskTypes;
  locations;
  schedules;
  existingSchedules;
  getDeskInfoSubscription: Subscription;
  getDeskSubscriptionRefresh: Subscription;
  getSmsListSubscription: Subscription;
  getTicketListSubscription: Subscription;
  getDeskDevicesSubscription: Subscription;
  getDeskTypesSubscription: Subscription;
  getDeskLocationsSubscription: Subscription;
  getDeskSchedulesSubscription: Subscription;

  constructor(private desksTurnsService: DesksTurnsService,
    private ticketsService: TicketsService,
    private userStorageService: UserStorageService,
    private activatedRoute: ActivatedRoute,
    private snackbarService: SnackBarService,
    private smsService: SmsService,
    private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getSmsList();
    this.getDeskTypes();
    this.getDeskInfo();
    this.getSchedules();
    this.getDeskSubscriptionRefresh = this.desksTurnsService.refreshDeskListen().subscribe(
      (res) => {
        this.getDeskInfo();
        this.getSchedules();
      }
    );
  }

  private getDeskInfo() {
    const internalId = this.activatedRoute.snapshot.params['deskid'];
    this.getDeskInfoSubscription = this.desksTurnsService.getDeskInfo(internalId).subscribe(
      (res) => {
        this.desk = res;
        this.assignedDevices = this.desk.DevicesBound;
        this.assignedLocations = this.desk.LocationsBound;
        this.getDeskDevices();
        this.getTicketList(this.desk.CenterInternalId);
        this.getLocations();
        this.getDeskExistingSchedules();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getSchedules() {
    const internalId = this.activatedRoute.snapshot.params['deskid'];
    this.getDeskSchedulesSubscription = this.desksTurnsService.getDeskScheduleList(internalId).subscribe(
      (res) => {
        this.schedules = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getSmsList() {
    this.getSmsListSubscription = this.smsService.getSmsList().subscribe(
      (res) => {
        this.smsList = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getTicketList(centerInternalId) {
    this.getTicketListSubscription = this.ticketsService.getTicketListByCenters([centerInternalId]).subscribe(
      (res) => {
        this.ticketList = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getDeskTypes() {
    this.getDeskTypesSubscription = this.desksTurnsService.getDeskTypes().subscribe(
      (res) => {
        this.deskTypes = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getDeskDevices() {
    this.getDeskDevicesSubscription = this.desksTurnsService.getDeskDevices(this.desk.CenterInternalId).subscribe(
      (res) => {
        const devices = new Array<DeviceBasic>();
        res['data']['deviceList'].forEach(
          (d) => {
            const device = new DeviceBasic();
            Object.assign(device, d);
            devices.push(device);
          }
        );
        this.devices = devices;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getLocations() {
    this.getDeskLocationsSubscription = this.desksTurnsService.getDeskLocations(this.desk.CenterInternalId, this.desk.TurnTypeInternalId).subscribe(
      (res) => {
        if (res) {
          this.locations = res;
        }
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getDeskExistingSchedules() {
    this.desksTurnsService.getDeskExistingSchedules(this.desk.CenterInternalId).pipe(
      tap(o => this.existingSchedules = o)
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-desktop', 'turns-page.desk detail', '/turns/desks', [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.desks', '/turns/desks'), new BRoute('turns-page.desk detail')]));
  }

  ngOnDestroy() {
    if (this.getDeskInfoSubscription) { this.getDeskInfoSubscription.unsubscribe(); }
    if (this.getDeskSubscriptionRefresh) { this.getDeskSubscriptionRefresh.unsubscribe(); }
    if (this.getSmsListSubscription) { this.getSmsListSubscription.unsubscribe(); }
    if (this.getTicketListSubscription) { this.getTicketListSubscription.unsubscribe(); }
    if (this.getDeskDevicesSubscription) { this.getDeskDevicesSubscription.unsubscribe(); }
    if (this.getDeskTypesSubscription) { this.getDeskTypesSubscription.unsubscribe(); }
    if (this.getDeskLocationsSubscription) { this.getDeskLocationsSubscription.unsubscribe(); }
    if (this.getDeskSchedulesSubscription) { this.getDeskSchedulesSubscription.unsubscribe(); }
  }

}
